import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShowHistoryComponent } from './show-history/show-history.component';
import { OrderTypeLogComponent } from './order-type-log/order-type-log.component';
import {NzTableModule} from 'ng-zorro-antd/table';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {DxButtonModule, DxDataGridModule, DxDateBoxModule} from 'devextreme-angular';
import { NzButtonModule } from 'ng-zorro-antd/button';

@NgModule({
  declarations: [
    ShowHistoryComponent,
    OrderTypeLogComponent
  ],
  imports: [
    CommonModule,
    NzTableModule,
    NzModalModule,
    FormsModule,
    ReactiveFormsModule,
    DxButtonModule,
    DxDataGridModule,
    DxDateBoxModule,
    NzButtonModule
  ],
  exports: [
    ShowHistoryComponent,
    OrderTypeLogComponent,
    NzTableModule,
    NzModalModule,
    FormsModule,
    ReactiveFormsModule,
    DxButtonModule,
    DxDataGridModule,
    DxDateBoxModule,
    NzButtonModule
  ]
  
})
export class ModalsModule  { }
